<template>
  <div class="base-info">
    <div class="base-head">
      <Input v-if="editShow" v-model="orgNameShow" placeholder="请输入服务名称" style="width: 200px"></Input>
      <span v-else>服务名称：{{ orgName }}</span>
      <div v-if="editShow">
        <Button type="primary" @click="handleFinish">完成</Button>
        <Button @click="handleCancle">取消</Button>
      </div>
      <Button v-else type="primary" @click="handleModify">修改</Button>
    </div>
    <DataInfoBlock :info-format="orgBaseInfoFormat"></DataInfoBlock>
    <DataInfoBlock :info-format="coInfoFormat"></DataInfoBlock>
    <DataInfoBlock :info-format="dtlInfoFormat"></DataInfoBlock>
    <div class="tabs-box">
      <Tabs value="name1">
        <TabPane
          :label="'学校统计（' + sysOrgSchoolDetails.length + '）'"
          name="name1"
        >
          <div
            v-for="(item, index) in sysOrgSchoolDetails"
            :key="index"
            class="sch-info-box"
          >
            <div class="sch-info-title">服务学校 ＃{{ index + 1 }}</div>
            <div class="sch-info-content">
              <Row>
                <Col span="8">
                <span class="info-label">学校名称：</span>
                <span class="info-value">{{ item.schoolName }}</span>
                </Col>
                <Col span="8">
                <span class="info-label">所属教育局：</span>
                <span class="info-value">{{ item.educationBureauName }}</span>
                </Col>
                <Col span="8"></Col>
              </Row>
              <Row>
                <Col span="8">
                <span class="info-label">学校负责人：</span>
                <span class="info-value">{{ item.chargeName }}</span>
                </Col>
                <Col span="8">
                <span class="info-label">联系方式：</span>
                <span class="info-value">{{ item.chargePhone }}</span>
                </Col>
                <Col span="8"></Col>
              </Row>
              <Row>
                <Col span="8">
                <span class="info-label">使用课程数：</span>
                <span class="info-value">{{ item.courseCount }}</span>
                </Col>
                <Col span="8">
                <span class="info-label">课程累计服务学生：</span>
                <span class="info-value">{{ item.studentCount }}</span>
                </Col>
                <Col span="8">
                <span class="info-label">收费总金额</span>
                <span
                  class="info-value"
                >¥ {{ item.payFeeSum | changYuan }}</span>
                </Col>
              </Row>
            </div>
          </div>
        </TabPane>
        <TabPane label="教育局统计" name="name2">
          <div
            v-for="(item, index) in orgEducationBureauDetails"
            :key="index"
            class="sch-info-box"
          >
            <div class="sch-info-title">服务教育局 ＃{{ index + 1 }}</div>
            <div class="sch-info-content">
              <Row>
                <Col span="8">
                <span class="info-label">教育局名称：</span>
                <span class="info-value">{{ item.educationBureauName }}</span>
                </Col>
                <Col span="8">
                <span class="info-label">联系方式：</span>
                <span class="info-value">{{ item.chargePhone }}</span>
                </Col>
                <Col span="8"></Col>
              </Row>
              <Row>
                <Col span="8">
                <span class="info-label">教育局负责人：</span>
                <span class="info-value">{{ item.chargeName }}</span>
                </Col>
                <Col span="8">
                <span class="info-label">区域：</span>
                <span class="info-value">{{ item.area }}</span>
                </Col>
                <Col span="8"></Col>
              </Row>
              <Steps v-if="userInfo.userType===5" :current="item.StepsCurrent" style="margin-top:20px">
                <Step
                  title="创建"
                  :content="item.recommendName + '\n' + item.recommendTime"
                ></Step>
                <Step
                  :title="item.educationBureauName"
                  :content="item.reviewName + item.reviewStateTxt"
                ></Step>
                <Step title="完成" :content="item.reviewTime"></Step>
              </Steps>
            </div>
          </div>
        </TabPane>
      </Tabs>
    </div>
  </div>
</template>
<script>
import { getYuan } from '@/utils/utils';
import DataInfoBlock from '@/pages/assetsModules/DataInfo/DataInfoBlock.vue';
import {
  orgBaseInfoFormat,
  coInfoFormat,
  dtlInfoFormat,
  changeDictionaries,
  orgKindList,
  cooperationList,
  completeStatusList,
  orgEduRankList
} from '@/utils/dictionary.js';
import { mapState } from 'vuex';
export default {
  name: 'OrgBaseInfo',
  filters: {
    // 将分转成元
    changYuan(money) {
      if (money) {
        return getYuan(money);
      }
      return '--';
    }
  },
  components: {
    DataInfoBlock
  },
  props: {
    // 服务名称
    orgName: {
      type: String,
      default: ''
    },
    // 学校列表
    sysOrgSchoolDetails: {
      type: Array,
      default: () => []
    },
    // 教育信息列表
    orgEducationBureauDetails: {
      type: Array,
      default: () => []
    },
    // 详情基础信息
    baseInfo: {
      type: Object,
      default: () => {}
    },
    // 详情合作信息
    coInfo: {
      type: Object,
      default: () => {}
    },
    // 详情详细信息
    dtlInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      columns12: [
        {
          title: '校区代码',
          key: 'branchId'
        },
        {
          title: '校区名称',
          key: 'branchName'
        },
        {
          title: '区域',
          key: 'area'
        },
        {
          title: '地址',
          key: 'address'
        },
        {
          title: '校区电话',
          key: 'branchPhone'
        },
        {
          title: '校区座机',
          key: 'branchTellphone'
        },
        {
          title: '创建时间',
          key: 'createTime'
        }
      ],
      editData: [], // 修改数据
      // 基础信息
      orgBaseInfoFormat: { ...orgBaseInfoFormat },
      // 合作信息
      coInfoFormat: { ...coInfoFormat },
      // 详细信息
      dtlInfoFormat: { ...dtlInfoFormat },
      orgKindList: changeDictionaries(orgKindList), // 单位类别列表
      cooperationList: changeDictionaries(cooperationList), // 合作状态列表
      completeStatusList: changeDictionaries(completeStatusList), // 信息完善状态
      orgEduRankList: changeDictionaries(orgEduRankList), // 单位级别
      orgNameShow: '',
      editShow: false
    };
  },
  computed: { ...mapState(['userInfo']) },
  watch: {
    baseInfo(newVal, oldVal) {
      this.dealBaseInfoData(newVal);
    },
    coInfo(newVal, oldVal) {
      this.dealCoInfoFormat(newVal);
    },
    dtlInfo(newVal, oldVal) {
      this.dealDtlInfoFormat(newVal);
    }
  },
  methods: {
    // 处理基础信息
    dealBaseInfoData(baseInfo) {
      this.orgBaseInfoFormat.list.forEach(item => {
        switch (item.key) {
          default:
            item.value = baseInfo[item.key];
            break;
        }
      });
      console.log(this.orgBaseInfoFormat, '是啊哈---');
    },
    // 处理合作信息
    dealCoInfoFormat(coInfo) {
      this.coInfoFormat.list.forEach(item => {
        switch (item.key) {
          case 'orgKind':
            item.value = this.orgKindList[coInfo.orgKind];
            break;
          case 'coSts':
            item.value = this.cooperationList[coInfo.coSts];
            break;
          default:
            item.value = coInfo[item.key];
            break;
        }
      });
    },
    // 处理详细信息
    dealDtlInfoFormat(dtlInfo) {
      this.dtlInfoFormat.list.forEach(item => {
        switch (item.key) {
          default:
            item.value = dtlInfo[item.key];
            break;
        }
      });
    },
    // 点击修改
    handleModify() {
      this.orgNameShow = this.orgName;
      this.editShow = true;
    },
    handleFinish() {
      this.$emit('modifyOrgName', this.orgNameShow);
    },
    handleCancle() {
      this.editShow = false;
      this.orgNameShow = '';
    },
    updatedOrgName() {
      this.editShow = false;
      this.orgNameShow = '';
    }
  }
};
</script>
<style lang="scss" scoped>
.base-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 24px 0;
  Button+Button{
    margin-left:16px;
  }
}
.org-branch {
  margin-top: 16px;
  .org-branch-table {
    margin-top: 16px;
    padding: 0 32px;
  }
}
.tabs-box {
  margin-top: 48px;
}
.sch-info-box {
  border-radius: 8px;
  border: 1px solid #e5e5e5;
  .sch-info-title {
    height: 50px;
    background: #f5f7f9;
    padding: 0 20px;
    font-size: 14px;
    font-weight: 600;
    color: #666;
    line-height: 50px;
  }
  .sch-info-content {
    padding: 16px;
    .info-label {
      line-height: 32px;
      margin-right: 16px;
      //width: 300px;
    }
    .info-value {
      line-height: 32px;
    }
  }
}
.sch-info-box + .sch-info-box {
  margin-top: 16px;
}
</style>
